import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => `The password must contain at least: 1 uppercase letter, 1 lowercase letter and 1 number.`,
  validate: (value) => {
    const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"); // eslint-disable-line no-useless-escape
    return strongRegex.test(value);
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vee-validate.js